/* eslint-disable linebreak-style */
/* eslint-disable @typescript-eslint/no-explicit-any */
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { IColumnTable } from '../interfaces/table.interface';
import * as FileSaver from 'file-saver';
export interface ISettingToExport {
  title: string;
  columns: IColumnTable[];
  data: any[];
}
const formatDate = (date: Date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

  return `${day}/${month}/${year},${formattedTime}`;
};

export class ExportUtil {
  static exportPdf(setting: ISettingToExport): void {
    const exportColumns = setting.columns.map((col) => col.header);
    const columsFiels = setting.columns.map((col) => col.field);
    const body = setting.data.map((item) =>
      columsFiels.map((field) => item[field])
    );
    const doc = new jsPDF({
      orientation: 'l',
      format: 'a4'
    });
    doc.setFontSize(20);
    doc.text(setting.title, 15, 10);
    autoTable(doc, { theme: 'grid', head: [exportColumns], body: [...body] });
    doc.save(`${setting.title}.pdf`);
  }

  static exportExcel(setting: ISettingToExport) {
    const body = setting.data.map((item) => {
      const row = {};
      setting.columns.forEach((col) => {
        const field = col.exportField || col.field;
        if (item[field] instanceof Date) {
          // if (Object.prototype.toString.call(item[col.field]) === "[object Date]") {
          row[col.header] = formatDate(item[field]);
        } else {
          row[col.header] = item[field];
        }
      });
      return row;
    });
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(body);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      ExportUtil.saveAsExcelFile(excelBuffer, setting.title);
    });
  }

  static exportExcelCustom(fields: string[], data: any[], title: string) {
    const body = data.map((item) => {
      const row = {};
      fields.forEach((field) => {
        if (item[field] instanceof Date) {
          row[field] = formatDate(item[field]);
        } else {
          row[field] = item[field];
        }
      });
      return row;
    });
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(body);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      ExportUtil.saveAsExcelFile(excelBuffer, title);
    });
  }

  static saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }
}
